import { useNavigate } from 'react-router-dom';
import '../assets/styles/pages/_portal-selection.scss';

const PortalSelection = () => {
    const navigate = useNavigate();

    const handleLegacyClick = () => {
        // Direct redirect to legacy portal
        window.location.href = process.env.REACT_APP_SIGN_IN_URI || process.env.REACT_APP_LEGACY_PORTAL_URL || 'https://my.rvos.com';
    };

    const handleNewClick = () => {
        // Direct redirect to new INow portal
        window.location.href = process.env.REACT_APP_INOW_PORTAL_URL || 'https://rvos-uat-sp.mu-1-us-west-2.guidewire.net';
    };

    const handleHelpMeDecideClick = () => {
        navigate('/help-me-decide');
    };

    return (
        <div className="portal-selection-page">
            <div className="container">
                <div className="portal-selection-content">
                    <h1 className="portal-selection-title">Login</h1>
                    
                    <div className="portal-selection-description">
                        <p>
                            We're rolling out a new computer system. During this transition, customer accounts will be gradually moved to the new platform.
                        </p>
                        <p className="portal-selection-instruction">
                            Please select the MyRVOS Customer Portal you wish to visit.
                        </p>
                    </div>

                    <div className="portal-selection-buttons">
                        <button
                            type="button"
                            className="button-gradient portal-button portal-button-legacy"
                            onClick={handleLegacyClick}
                        >
                            MyRVOS Legacy
                        </button>
                        <button
                            type="button"
                            className="button-gradient portal-button portal-button-new"
                            onClick={handleNewClick}
                        >
                            MyRVOS New
                        </button>
                    </div>

                    <div className="portal-selection-help">
                        <button
                            type="button"
                            className="portal-help-link"
                            onClick={handleHelpMeDecideClick}
                        >
                            Help me decide
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PortalSelection;

